import React, { useEffect, useState } from "react";
import BusinessInformation from "./AddClient/BusinessInformation";
import GeneralInformation from "./AddClient/GeneralInformation";
import Accounts from "./AddClient/Accounts";
import Contacts from "./AddClient/Contacts";
import AdditionalInformation from "./AddClient/AdditionalInformation";
import Documents from "./AddClient/Documents";
import TimesheetSettings from "./AddClient/TimesheetSettings";
import SubCustomers from "./AddClient/SubCustomers";
import { NewTab, PageTab } from "../../../components";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearClientProfile } from "../../../redux/slices/client/clientSlice";
import Invoicesandpayments from "./AddClient/Invoicesandpayments";
import Placements from "./AddClient/Placements";

const AddClient = ({ isEditable = false, clientId, setActiveTab }) => {
  const location = useLocation();
  const editClient = location.pathname;
  if (editClient == "/client/add-client") {
    isEditable = true;
  }
  const clientProfileUiid = useSelector(
    (state) => state.client.clientProfileUiid
  );
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(clearClientProfile());
    };
  }, []);

  const EmployeeMenus = [
    {
      title: "Business Information",
      page: (
        <BusinessInformation
          isEditable={isEditable}
          editClient={editClient}
          clientId={clientId}
        />
      ),
      type: "main",
    },
    {
      title: "General Information",
      page: (
        <GeneralInformation
          isEditable={isEditable}
          editClient={editClient}
          clientId={clientId}
        />
      ),
      type: "main",
    },
    // {
    //   title: "Accounts",
    //   page: (
    //     <Accounts
    //       isEditable={isEditable}
    //       editClient={editClient}
    //       clientId={clientId}
    //     />
    //   ),
    //   type: "main",
    // },
    {
      title: "Contacts",
      page: (
        <Contacts
          isEditable={isEditable}
          editClient={editClient}
          clientId={clientId}
        />
      ),
      type: "main",
    },
    {
      title: "Additional Information",
      page: (
        <AdditionalInformation
          isEditable={isEditable}
          editClient={editClient}
          clientId={clientId}
        />
      ),
      type: "main",
    },
    {
      title: "Documents",
      page: (
        <Documents
          isEditable={isEditable}
          editClient={editClient}
          clientId={clientId}
        />
      ),
      type: "main",
    },
    {
      title: "Placements",
      page: (
        <Placements
          isEditable={isEditable}
          editClient={editClient}
          clientId={clientId}
        />
      ),
      type: "main",
    },
    {
      title: "Invoices and payments",
      page: (
        <Invoicesandpayments
          isEditable={isEditable}
          editClient={editClient}
          clientId={clientId}
        />
      ),
      type: "main",
    },
    // {
    //   title: "Timesheet Settings",
    //   page: (
    //     <TimesheetSettings
    //       isEditable={isEditable}
    //       editClient={editClient}
    //       clientId={clientId}
    //     />
    //   ),
    //   type: "main",
    // },
    // {
    //   title: "Sub-Customers",
    //   page: (
    //     <SubCustomers
    //       isEditable={isEditable}
    //       editClient={editClient}
    //       clientId={clientId}
    //     />
    //   ),
    //   type: "main",
    // },
    // {
    //   title: "Placements",
    //   page: (
    //     <Placements
    //       isEditable={isEditable}
    //       editClient={editClient}
    //       clientId={clientId}
    //     />
    //   ),
    //   type: "main",
    // },
  ];

  return (
    <>
      <NewTab
        tabs={EmployeeMenus}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="add-client"
      />
    </>
  );
};

export default AddClient;
